import {
  GetInspectionsQuery,
  GetInspectionsQueryVariables,
} from '@/api/ariadne/__generated_types__/graphql';
import { GET_FILTERED_INSPECTIONS } from '@/api/ariadne/queries/get-filtered-inspections-query';
import { client } from '@/utils/gqlapi';

export const getFilteredInspections = ({ regionId }: { regionId: string }) =>
  client.query<GetInspectionsQuery, GetInspectionsQueryVariables>({
    query: GET_FILTERED_INSPECTIONS,
    variables: { regionId },
  });
